export const SET_SELECTED_TABLE_LAYOUT_ID = 'SET_SELECTED_TABLE_LAYOUT_ID'
export const SET_TABLE_SERVICE_TABLE_LAYOUT = 'SET_TABLE_SERVICE_TABLE_LAYOUT'
export const SET_TABLE_SERVICE_TEMP_TABLE_STATUS =
    'SET_TABLE_SERVICE_TEMP_TABLE_STATUS'
export const PATCH_TABLE_SERVICE_TABLE_GUEST_COUNT =
    'PATCH_TABLE_SERVICE_TABLE_GUEST_COUNT'
export const SET_TABLE_SERVICE_ORDER_STOCK_AVAILABILITY_ERROR =
    'SET_TABLE_SERVICE_ORDER_STOCK_AVAILABILITY_ERROR'
